/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'invite-your-team',
  title: 'Invite your team, roles and teams',
  category: 'Getting started',
  summary:
    'Invite colleagues by email, choose who is owner, admin or member, group people into teams that see only their projects, and handle access requests.',
  keywords: [
    'invite', 'invitation', 'team', 'members', 'colleague', 'roles', 'owner', 'admin', 'member',
    'access request', 'request access', 'remove member', 'transfer ownership', 'organization', 'teams',
    'agency', 'clients', 'project access', 'permissions',
  ],
};

export const loadComponent = () => import('./invite-your-team.component').then((m) => m.InviteYourTeamArticleComponent);
